import { initLoader } from './modules/_initLoader.js';
import { initDrawerMenu } from './modules/_initDrawerMenu.js';
import {
  initScrollAnimationHeader,
  initScrollAnimationContents,
} from './modules/_initScrollAnimation.js';
import { loadAndRenderItems } from './modules/_loadAndRenderItems.js';
import { loadAndRenderItemsModal } from './modules/_loadAndRenderItemsModal.js';
import { loadAndFilterItemsByDate } from './modules/_loadAndFilterItemsByDate.js';
import { initModalWindow } from './modules/_initModalWindow.js';
import { initPaginationStyling } from './modules/_initPaginationStyling.js';
import { pvCounter } from './modules/_pvCounter.js';
import { initSmoothScroll, scrollOnLoadHash } from './modules/_initSmoothScroll.js';
import { linkOption } from './modules/_linkOption.js';

document.addEventListener('DOMContentLoaded', () => {
  // DOMが準備でき次第、すぐに実行すべき初期化処理
  initLoader();
  initScrollAnimationHeader();
  initScrollAnimationContents();
  initDrawerMenu();
  initModalWindow();
  initPaginationStyling();
  initSmoothScroll();
  linkOption();
  pvCounter();
  const settings = window.bone_duck_theme_vars || {};
  if (settings.features?.json_list) loadAndRenderItems();
  if (settings.features?.json_modal) loadAndRenderItemsModal();
  if (settings.features?.json_schedule) {
    const schedule = settings.schedule || {};
    loadAndFilterItemsByDate(schedule.jsonUrl, schedule.targetSelector, schedule);
  }
});

// ページ上のすべてのリソース（画像など）が読み込まれた後に実行すべき処理
window.addEventListener('load', () => {
  // スムーズスクロールなど、画像サイズに依存する可能性のある処理
  scrollOnLoadHash();
});
